export const menuDynamic = [
  {
    id: 1,
    text: 'Painel Geral',
    clickable: true,
    componentName: 'PainelGeral',
  },
  { id: 2, text: 'Modo Apresentação', icon: 'Maximize', clickable: true },
];
